import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/customer-refund-payment/constants'

const propTypes = {
  status: PropTypes.string
}

const defaultProps = {
  status: 'accepted'
}

/**
 * @param {string} status
 */
const CustomerRefundPaymentStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.ACCEPTED] : 'info',
    [STATUS.PENDING]  : 'warning',
    [STATUS.REJECTED] : 'danger',
    [STATUS.REFUNDED] : 'success',
    [STATUS.RETURNED] : 'primary'

  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerRefundPaymentStatusBadge.propTypes    = propTypes
CustomerRefundPaymentStatusBadge.defaultProps = defaultProps

export default CustomerRefundPaymentStatusBadge
